import { getOrgTemplateLibraries } from 'src/redux/slices/project/endpoints'

import { Grid } from '@material-ui/core'

import Library from './Library'

const LibraryList: React.FC = () => {
  const { data: libraries, isLoading } = getOrgTemplateLibraries.useQuery('')
  return (
    <Grid container>
      {libraries?.map((library) => (
        <Library library={library} key={library.id} />
      ))}
    </Grid>
  )
}
export default LibraryList
